import * as moment from 'moment';

/**
 * Receipt REST timestamps are persisted as UTC wall-clock; naive ISO strings (no offset) must be parsed as UTC,
 * otherwise the browser treats them as local and CET/CEST are wrong.
 */
function parseReceiptApiDateTime(raw: string): moment.Moment | null {
  const s = raw.trim();
  if (!s) return null;
  if (/[zZ]$|[+-]\d{2}:?\d{2}$|[+-]\d{4}$/.test(s)) {
    return moment(s);
  }
  return moment.utc(s);
}

/** Format receipt/fiscal API datetimes for display in the user's local timezone. */
export function formatReceiptUtcForDisplay(
  date: string | Date | null | undefined,
  format: string,
): string {
  if (date == null) return '';
  if (date instanceof Date) {
    if (isNaN(date.getTime())) return '';
    return moment(date).format(format);
  }
  const s = String(date).trim();
  if (!s) return '';
  const m = parseReceiptApiDateTime(s);
  return m ? m.local().format(format) : '';
}
